/**
 * @module components/Checkout/CheckoutButton
 * @description Checkout button component with animated arrow icon.
 * Triggers checkout flow opening from cart summary.
 */

import React from 'react';

/**
 * @typedef CheckoutButtonProps
 * @property {string} [className] - Optional CSS class name
 * @property {React.MouseEventHandler} onClick - Click event handler to open checkout
 */

/**
 * @component CheckoutButton
 * @type {React.FC<CheckoutButtonProps>}
 * @summary Styled checkout button with right arrow icon.
 * Triggers transition from cart view to full checkout form.
 * @param {CheckoutButtonProps} props - Component props
 * @returns {React.ReactElement} Button with SVG arrow icon
 */
export const CheckoutButton = (props) => (
  <div className={props.className}>
    <button
      className="if jcs aic my05 hover block asset__add-to-cart caps akz black"
      id="checkout-button-sku_G9OyKbsxZ5RNDI"
      role="link"
      onClick={props.onClick}
    >
      Checkout
      <div className="asset__add-to-cart__arrow ml05">
        <svg
          fill="currentColor"
          version="1.1"
          id="Layer_1"
          x="0px"
          y="0px"
          viewBox="0 0 55 20"
        >
          <polygon
            fillRule="evenodd"
            clipRule="evenodd"
            points="43.3,0 55,10 43.3,20 42.4,19.1 52.2,10.7 0,10.7 0,9.3 52.2,9.3   42.4,0.9 43.3,0 "
          />
        </svg>
      </div>
    </button>
  </div>
);
